"use client"

import { useState } from "react"

const OtherQueryInput = ({ handleQuerySubmit, isQueryInputDisabled }) => {
  const [query, setQuery] = useState("")

  const handleSubmit = () => {
    if (query.trim()) {
      handleQuerySubmit(query)
      setQuery("")
    }
  }

  return (
    <div className="user-form-container other-query-form">
      <div className="form-header">
        <h6>To better assist you, please describe your requirement:</h6>
      </div>

      <div className="form-group">
        <div className="query-input-wrapper-pro">
          <textarea
            className="form-input query-textarea"
            placeholder="Type your requirement here..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && e.ctrlKey) {
                handleSubmit()
              }
            }}
            disabled={isQueryInputDisabled}
            rows="4"
          />
        </div>
      </div>

      <button
        className="form-submit-button query-submit-pro"
        onClick={handleSubmit}
        disabled={!query.trim() || isQueryInputDisabled}
        title="Submit query"
      >
        <span className="button-text">Submit Requirement</span>
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          className="button-icon"
        >
          <line x1="22" y1="2" x2="11" y2="13"></line>
          <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
        </svg>
      </button>
    </div>
  )
}

export default OtherQueryInput
